import React from "react";
import { useState, useEffect,useRef } from "react";
import axios from "axios";
import styles from "./NewsListing.module.sass";
import NewsCard from "../../components/NewsCard";
import NewsSection from "../../components/NewsSection";
import NewsListingCard from "../../components/NewsListingCard";
import CustomPagination from "../../components/CustomPagination";
import SubscribeforUpdates from "../../components/SubscribeforUpdates";
import TopicsOnAgenda from "../../components/TopicsOnAgenda";
export default function NewsListing() {
  const topRef = useRef(null);

  const [data, setData] = useState({
    news: [],
    topnews: [],
    totalPages: 0,
    currentPage: 1,
    topNewsSingle: {},
    totalItems: 0,
  });
  const getTopNews = () => {
    axios
      .get(`${process.env.REACT_APP_API_SERVER_URL}/top-news`)
      .then((data) => {
        setData((prev) => ({
          ...prev,
          topnews: data?.data?.data || [],
          topNewsSingle: data?.data?.topNewsSingle || {},
        }));
      });
  };
  const getAllNews = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_SERVER_URL}/news?page=${data.currentPage}&limit=6`
      )
      .then(({ data }) => {
        setData((prev) => ({
          ...prev,
          news: data?.data,
          totalPages: data?.totalPages,
          totalItems: data?.total,
        }));
      });
  };
  useEffect(() => {
    getTopNews();
  }, []);
  useEffect(() => {
    getAllNews();
  }, [data?.currentPage]);

  const handlePageChange = (page) => {
    setData((prev) => ({ ...prev, currentPage: page }));
    topRef.current?.scrollIntoView({ behavior: 'smooth' });

  };
  const truncateText = (text, limit = 138) => {
    const strippedText = text.replace(/(<([^>]+)>)/gi, "");
    return strippedText.length > limit
      ? `${strippedText.substring(0, limit)}`
      : strippedText;
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.darkContainer}>
          <div className={styles.topNewsContainerOuter}>
            <h1 className={styles.top_news_heding}>Top News</h1>
            <div className={styles.topNewsContainer}>
              {data?.topNewsSingle && (
                <div className={styles.left}>
                  <NewsCard
                    className={styles.left_sub}
                    id={data?.topNewsSingle.id}
                    Image={`${process.env.REACT_APP_API_SERVER_URL}/${
                      data?.topNewsSingle?.image || ""
                    }`}
                    date={data?.topNewsSingle?.publishdate || ""}
                    category={data?.topNewsSingle?.category?.name || ""}
                    title={data?.topNewsSingle?.title || ""}
                    description={truncateText(
                      data?.topNewsSingle?.shortdescription || ""
                    )}
                    url={data?.topNewsSingle?.url}
                  />
                </div>
              )}
              {data?.topnews && (
                <div className={styles.right}>
                  <div className={styles.rightTop}>
                    {data?.topnews.map((item) => (
                      <NewsCard
                        Image={`${process.env.REACT_APP_API_SERVER_URL}/${
                          item?.image || ""
                        }`}
                        date={item?.publishdate || ""}
                        category={item?.category?.name || ""}
                        title={item?.title || ""}
                        isSmall={true}
                        url={item?.url}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.latestNewsContainer}>
            <NewsSection isFullWidth={false} isListingPage={true} />
          </div>
        </div>
        <div className={styles.lightContainer} ref={topRef}>
          <div className={styles.newsListingContainer}>
            {data?.news && data?.news?.length > 0 ? (
              data?.news?.map((data, index) => {
                return (
                  <NewsListingCard
                    key={index}
                    image={`${process.env.REACT_APP_API_SERVER_URL}/${data?.image}`}
                    category={data?.category?.name}
                    title={data?.title}
                    date={data?.publishdate}
                    url={data?.url}
                    description={truncateText(data?.shortdescription || "")}
                  />
                );
              })
            ) : (
              <p>No News found</p>
            )}
          </div>
          {data?.totalItems > 6 ? (
            <CustomPagination
              totalPages={data.totalPages}
              currentPage={data.currentPage}
              onPageChange={handlePageChange}
            />
          ) : null}
        </div>
        <TopicsOnAgenda isNews={true} />
        <SubscribeforUpdates />
      </div>
    </>
  );
}
